import { render, staticRenderFns } from "./TestParentPay.vue?vue&type=template&id=5c9990e0&scoped=true&"
import script from "./TestParentPay.vue?vue&type=script&lang=js&"
export * from "./TestParentPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9990e0",
  null
  
)

export default component.exports